import type { CabinBaggageDetails, CheckedBaggage, Maybe } from '@eti/schema-types';
import { constants } from '@eti/utils';

export const getIncludedBaggageText = (
  baggageDetails: Maybe<CheckedBaggage> | Maybe<CabinBaggageDetails> | undefined,
  textKey: string,
  t: (key: any, ...params: any[]) => string,
) => {
  if (!baggageDetails) {
    return null;
  }
  const { pieces, weight, weightUnit } = baggageDetails;
  const { LRE, PDF } = constants.unicodeControlCharacters;
  if (pieces && weight && weightUnit) {
    return t(textKey, `${LRE}${pieces}×${weight}${weightUnit}${PDF}`);
  }
  if (pieces) {
    return t(textKey, pieces);
  }
  if (pieces === null && weight && weightUnit) {
    return t(textKey, `${weight}${weightUnit}${PDF}`);
  }
  return '';
};
